module.exports = __webpack_public_path__ + "img/171.5c1699f0.png";